import React, { useState, useContext, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Button, Select, InputLabel, FormControl
} from "@material-ui/core";

import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import logo from "../../images/logo.png"


// styles
import useStyles from "./styles";

// components
import { Typography } from "../Wrappers/Wrappers";
import {isMobile} from 'react-device-detect';

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";
import { AuthContext } from "../../context/AuthContext";

import { connect } from "react-redux";

function Header(props) {
  // global
  const classes = useStyles();

  const { logout, getAuthUser } = useContext(AuthContext)


  const authUser = getAuthUser()

  // local
  var [profileMenu, setProfileMenu] = useState(null);


  return (
      <>
      
      <div
  className="float-start d-md-flex d-none flex-column justify-content-between align-items-center"
  style={{ width: "5%", backgroundColor: "#21386b", height: "100vh" }}
>
  {/* Logo at the Top */}
  <img src={logo} className="img-fluid mt-3" alt="logo" style={{ height: 40 }} />

  {/* IconButton at the Bottom */}
  <IconButton
    aria-haspopup="true"
    color="inherit"
    className="mb-2 pt-5"
    onClick={(e) => setProfileMenu(e.currentTarget)}
  >
    <AccountCircleIcon classes={{ root: classes.headerIcon }} />
  </IconButton>

  {/* Profile Menu */}
  <Menu
    id="profile-menu"
    open={Boolean(profileMenu)}
    anchorEl={profileMenu}
    onClose={() => setProfileMenu(null)}
    className={classes.headerMenu}
    classes={{ paper: classes.profileMenu }}
    disableAutoFocusItem
     anchorOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
  >
    <div className={classes.profileMenuUser}>
        <div className="mb-3">
        <p className="text-capitalize mb-0">
        {authUser?.name} 
      </p>
      <Typography variant="h6" >
        {authUser?.email}
      </Typography>
        </div>
     
      <Button
        variant="contained"
        color="secondary"
        className={classes.logoutMenuButton}
        onClick={() => logout(props.history)}
      >
        Sign Out
      </Button>
    </div>

  </Menu>
</div>
     
        {/* <select class="form-select w-auto form-select-sm mx-2" value={business}
          onChange={handleInputChange}>
          <option selected>Select Business</option>

          {props.tenants.map(item => (
            <option value={item.id}>{item.name}</option>
          ))}
        </select> */}
       {/* {newmsgarr.length>0 && props.tenantnumbers.filter(t =>authUser.role==='agent'? authUser?.tenants?.includes(t.tenant.id): t)?.length>1 && <span className="me-3 shake"> <NotificationsActive /></span>}


        <select className={"form-select  form-select-sm ml-3 " + (isMobile ? "" : "w-auto")} value={phonenumber}
          onChange={handlephoneChange}>
          <option selected >Select Business Number</option>

          {props.tenantnumbers.filter(t =>authUser.role!=='superadmin'? authUser.tenants.includes(t.tenant.id): t).map(item => (
            <option value={item.phone_number}> {item.name} - {item.phone_number}  ({item?.tenant?.name}) {newmsgarr.includes(item.phone_number) ? '🔔' :''}</option>
          ))}
        </select> */}


      
      </>
 
  );
}

const mapStateToProps = state => ({

})

const mapActionToProps = {


}

export default connect(mapStateToProps, mapActionToProps)(Header);